export enum PublishStatus {
  Draft = 1,
  Published = 2,
  Archived = 3,
}